import { render, staticRenderFns } from "./ProjectsGeneralDetail.vue?vue&type=template&id=0e0e0b04&scoped=true&lang=pug&"
import script from "./ProjectsGeneralDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectsGeneralDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGeneralDetail.vue?vue&type=style&index=0&id=0e0e0b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e0b04",
  null
  
)

export default component.exports